import iziToast from 'izitoast';
import { parseError } from '@/utils/errorInterpreter';

/**
 * Show a toast for API failures when global error redirects are skipped.
 */
export function showApiErrorToast(error, title = 'Error') {
  // eslint-disable-next-line no-underscore-dangle
  if (error?.config?._silentError) return;
  const message = parseError(error);
  iziToast.error({
    title,
    message,
    position: 'topRight',
    timeout: 7000,
  });
}

export function showApiWarningToast(message, title = 'Notice') {
  iziToast.warning({
    title,
    message,
    position: 'topRight',
    timeout: 5000,
  });
}
